import React from 'react'
import CreativeNameDisplay from '../shared/CreativeNameDisplay'

function WebviewPreview({ preview }) {
  return (
    <>
      <CreativeNameDisplay preview={preview} />
      <div className="preview-inner">
        <div className="preview-full-image">
          {(preview.creativeurls || preview.video_urls) && <iframe className='w-full h-full' scrolling='no' src={encodeURI(preview.creativeurls || preview.video_urls)} alt="webviewad" title='webviewad'></iframe>
          }
          {/* {preview.button_enabled ? <div>
          <button style={{backgroundColor:preview.btn_text_bgclr,color:preview.btn_text_clr}} onClick={handleClick}>{preview.button_text}</button>
          <span>{(preview.position === 0 || preview.position ==="Top") ? "Top" : "Bottom"}</span>
        </div> : null} */}
        </div>
      </div>
    </>
  )
}

export default WebviewPreview